import inventoryCreateItemReducer from "./reducers";

export default inventoryCreateItemReducer;
